// extracted by mini-css-extract-plugin
module.exports = {"textareaWrap":"NPaxf","textarea":"NPae9","noResize":"NPaxh","error":"NPxt","textareaTop":"NPaxj","label":"NPt7","textareaCounter":"NPaxl","textareaError":"NPaxn"};